import React from 'react';
import { ScanLine, LayoutDashboard, Inbox, FileBarChart, Settings, ChevronRight } from 'lucide-react';
interface ScreenProps {
  onNavigate: (screenId: number) => void;
}
export function Screen8({
  onNavigate
}: ScreenProps) {
  return <div className="min-h-full bg-datmont-900 flex flex-col pb-20" data-id="element-333">
      {/* Header */}
      <div className="px-6 pt-6 pb-6 flex items-start justify-between" data-id="element-334">
        <div data-id="element-335">
          <h1 className="text-lg font-bold text-white mb-1" data-id="element-336">
            Institution Dashboard
          </h1>
          <p className="text-xs text-slate-400" data-id="element-337">VFS Global – Madrid</p>
        </div>
        <button className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center text-white hover:bg-white/20 transition-colors" data-id="element-338">
          <ScanLine className="w-5 h-5" data-id="element-339" />
        </button>
      </div>

      {/* Main Content Area */}
      <div className="flex-1 bg-slate-50 rounded-t-[32px] p-6 flex flex-col" data-id="element-340">
        <h2 className="text-sm font-bold text-datmont-900 mb-4" data-id="element-341">
          Incoming Verification Requests
        </h2>

        {/* Tabs */}
        <div className="flex border-b border-slate-200 mb-6" data-id="element-342">
          <button className="flex-1 pb-3 text-sm font-bold text-datmont-blue border-b-2 border-datmont-blue relative" data-id="element-343">
            Pending{' '}
            <span className="ml-1 px-1.5 py-0.5 bg-blue-100 text-datmont-blue text-[10px] rounded-full" data-id="element-344">
              12
            </span>
          </button>
          <button className="flex-1 pb-3 text-sm font-medium text-slate-500 hover:text-slate-700" data-id="element-345">
            Verified
          </button>
          <button className="flex-1 pb-3 text-sm font-medium text-slate-500 hover:text-slate-700" data-id="element-346">
            Rejected
          </button>
        </div>

        {/* Request List */}
        <div className="space-y-4 flex-1 overflow-y-auto custom-scrollbar pr-2" data-id="element-347">
          {/* Request 1 */}
          <div className="bg-white border border-slate-200 rounded-2xl p-4 shadow-sm" data-id="element-348">
            <div className="flex items-start justify-between mb-3" data-id="element-349">
              <div className="flex items-center gap-3" data-id="element-350">
                <div className="w-10 h-10 rounded-full bg-slate-200 overflow-hidden" data-id="element-351">
                  <img src="https://i.pravatar.cc/150?u=isaac" alt="Isaac Daniel" className="w-full h-full object-cover" data-id="element-352" />
                </div>
                <div data-id="element-353">
                  <h3 className="text-sm font-bold text-datmont-900" data-id="element-354">
                    Isaac Daniel
                  </h3>
                  <p className="text-[10px] text-slate-500" data-id="element-355">
                    FBI Identity Record
                  </p>
                </div>
              </div>
              <span className="px-2 py-1 bg-orange-50 text-orange-600 text-[9px] font-bold uppercase tracking-wider rounded border border-orange-100" data-id="element-356">
                Pending
              </span>
            </div>
            <p className="text-[10px] text-slate-400 mb-3" data-id="element-357">
              Submitted: Apr 1, 2024 10:30 AM
            </p>
            <button onClick={() => onNavigate(5)} className="w-full py-2 flex items-center justify-center gap-1 text-xs font-bold text-datmont-blue hover:bg-blue-50 rounded-lg transition-colors" data-id="element-358">
              Tap to Review <ChevronRight className="w-3 h-3" data-id="element-359" />
            </button>
          </div>

          {/* Request 2 */}
          <div className="bg-white border border-slate-200 rounded-2xl p-4 shadow-sm opacity-60" data-id="element-360">
            <div className="flex items-start justify-between mb-3" data-id="element-361">
              <div className="flex items-center gap-3" data-id="element-362">
                <div className="w-10 h-10 rounded-full bg-slate-200 overflow-hidden" data-id="element-363">
                  <img src="https://i.pravatar.cc/150?u=maria" alt="Maria Lopez" className="w-full h-full object-cover" data-id="element-364" />
                </div>
                <div data-id="element-365">
                  <h3 className="text-sm font-bold text-datmont-900" data-id="element-366">
                    Maria Lopez
                  </h3>
                  <p className="text-[10px] text-slate-500" data-id="element-367">
                    Birth Certificate
                  </p>
                </div>
              </div>
              <span className="px-2 py-1 bg-green-50 text-datmont-green text-[9px] font-bold uppercase tracking-wider rounded border border-green-100" data-id="element-368">
                Verified
              </span>
            </div>
            <p className="text-[10px] text-slate-400 mb-3" data-id="element-369">
              Submitted: Apr 1, 2024 09:15 AM
            </p>
            <button className="w-full py-2 flex items-center justify-center gap-1 text-xs font-bold text-slate-500 hover:bg-slate-50 rounded-lg transition-colors" data-id="element-370">
              Tap to View <ChevronRight className="w-3 h-3" data-id="element-371" />
            </button>
          </div>

          {/* Request 3 */}
          <div className="bg-white border border-slate-200 rounded-2xl p-4 shadow-sm" data-id="element-372">
            <div className="flex items-start justify-between mb-3" data-id="element-373">
              <div className="flex items-center gap-3" data-id="element-374">
                <div className="w-10 h-10 rounded-full bg-slate-200 overflow-hidden" data-id="element-375">
                  <img src="https://i.pravatar.cc/150?u=ali" alt="Ali Hassan" className="w-full h-full object-cover" data-id="element-376" />
                </div>
                <div data-id="element-377">
                  <h3 className="text-sm font-bold text-datmont-900" data-id="element-378">
                    Ali Hassan
                  </h3>
                  <p className="text-[10px] text-slate-500" data-id="element-379">
                    Marriage Certificate
                  </p>
                </div>
              </div>
              <span className="px-2 py-1 bg-orange-50 text-orange-600 text-[9px] font-bold uppercase tracking-wider rounded border border-orange-100" data-id="element-380">
                Pending
              </span>
            </div>
            <p className="text-[10px] text-slate-400 mb-3" data-id="element-381">
              Submitted: Mar 31, 2024 04:45 PM
            </p>
            <button className="w-full py-2 flex items-center justify-center gap-1 text-xs font-bold text-datmont-blue hover:bg-blue-50 rounded-lg transition-colors" data-id="element-382">
              Tap to Review <ChevronRight className="w-3 h-3" data-id="element-383" />
            </button>
          </div>
        </div>
      </div>

      {/* Bottom Nav */}
      <div className="absolute bottom-0 inset-x-0 h-20 bg-white border-t border-slate-100 flex items-center justify-around px-6 pb-4 z-20" data-id="element-384">
        <button className="flex flex-col items-center gap-1 text-datmont-blue" data-id="element-385">
          <LayoutDashboard className="w-6 h-6" data-id="element-386" />
          <span className="text-[10px] font-medium" data-id="element-387">Dashboard</span>
        </button>
        <button className="flex flex-col items-center gap-1 text-slate-400 hover:text-slate-600" data-id="element-388">
          <Inbox className="w-6 h-6" data-id="element-389" />
          <span className="text-[10px] font-medium" data-id="element-390">Requests</span>
        </button>
        <button className="flex flex-col items-center gap-1 text-slate-400 hover:text-slate-600" data-id="element-391">
          <FileBarChart className="w-6 h-6" data-id="element-392" />
          <span className="text-[10px] font-medium" data-id="element-393">Reports</span>
        </button>
        <button className="flex flex-col items-center gap-1 text-slate-400 hover:text-slate-600" data-id="element-394">
          <Settings className="w-6 h-6" data-id="element-395" />
          <span className="text-[10px] font-medium" data-id="element-396">Settings</span>
        </button>
      </div>
    </div>;
}